<script lang="ts">
    import type { Snippet } from 'svelte';
    import type { Page } from '@shared/types/Tilelist.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import SearchResult from '@tilelist/components/tile-list-page/SearchResult.svelte';

    type Props = { page: Page; children: Snippet };

    const { page, children }: Props = $props();

    const onex = injectWiring().onex;
    const visualRefreshActive = $derived(onex.isExperimentGroup('VISUAL_REFRESH', 'E3933B'));
</script>

<SearchResult {page} {visualRefreshActive}>
    {@render children()}
</SearchResult>
